<template>
  <b-container>
    <b-row >
        <b-col tag="section" cols="12">
          <content-loader class="d-none d-md-block"
            :height="330"
            :width="950"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#dedede"
          >
            <rect x="0" y="0" rx="5" ry="5" width="290" height="200" />
            <rect x="0" y="217" rx="4" ry="4" width="200" height="20" />
            <rect x="0" y="245" rx="0" ry="0" width="244" height="14" />
            <rect x="0" y="280" rx="0" ry="0" width="290" height="60" />

            <rect x="325" y="0" rx="5" ry="5" width="290" height="200" />
            <rect x="325" y="217" rx="4" ry="4" width="200" height="20" />
            <rect x="325" y="245" rx="0" ry="0" width="244" height="14" />
            <rect x="325" y="280" rx="0" ry="0" width="290" height="60" />

            <rect x="650" y="0" rx="5" ry="5" width="290" height="200" />
            <rect x="650" y="217" rx="4" ry="4" width="200" height="20" />
            <rect x="650" y="245" rx="0" ry="0" width="244" height="14" />
            <rect x="650" y="280" rx="0" ry="0" width="290" height="60" />
          </content-loader>

          <content-loader class="d-md-none text-center"
          :height="330"
            :width="350"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#dedede"
          >
            <rect x="0" y="0" rx="5" ry="5" width="350" height="200" />
            <rect x="0" y="217" rx="4" ry="4" width="200" height="20" />
            <rect x="0" y="245" rx="0" ry="0" width="244" height="14" />
            <rect x="0" y="280" rx="0" ry="0" width="350" height="60" />
          </content-loader>
        </b-col>
    </b-row>
   </b-container>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    ContentLoader
  }
}
</script>

<style>

</style>
